import PortableText from '@helsenorge/core-cms/richtext';
import type { BehandlingsvalgBeskrivelseBlockDto } from '@helsenorge/core-cms/types/entities/cms.v1entities';
import type { VimeoSubtitleLanguageCodes } from '@helsenorge/core-cms/videospiller/constants';

import { contentMapper } from '../../content-helper/contentMapper';

interface Props {
  /* Introduksjon til behandlingsvalget */
  introduction?: BehandlingsvalgBeskrivelseBlockDto['introduction'];
  /* Hovedinnholdet til behandlingsvalget */
  mainContent?: BehandlingsvalgBeskrivelseBlockDto['mainContent'];
  /* Avsluttende innhold for behandlingsvalget */
  ending?: BehandlingsvalgBeskrivelseBlockDto['avslutning'];
  subtitleLanguageCode?: VimeoSubtitleLanguageCodes;
}

const BehandlingsBeskrivelseBlock: React.FunctionComponent<Props> = ({
  introduction,
  mainContent,
  ending,
  subtitleLanguageCode,
}: Props) => {
  return (
    <>
      {introduction &&
        introduction.map((contentBlock, index) => {
          return contentMapper(contentBlock, index, [], false, undefined, subtitleLanguageCode);
        })}
      {mainContent &&
        mainContent.map((contentBlock, index) => {
          return contentMapper(contentBlock, index, [], false, undefined, subtitleLanguageCode);
        })}
      {ending && <PortableText value={ending}></PortableText>}
    </>
  );
};

export default BehandlingsBeskrivelseBlock;
